// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3n2y6","content":"LayoutSettings_content__14rMp"};